export default __webpack_public_path__ + "static/media/rcp.8f2f9541.png";